import { render, staticRenderFns } from "./RegistrationFormAgreement.vue?vue&type=template&id=597690a5&"
import script from "./RegistrationFormAgreement.vue?vue&type=script&setup=true&lang=ts&"
export * from "./RegistrationFormAgreement.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('597690a5')) {
      api.createRecord('597690a5', component.options)
    } else {
      api.reload('597690a5', component.options)
    }
    module.hot.accept("./RegistrationFormAgreement.vue?vue&type=template&id=597690a5&", function () {
      api.rerender('597690a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/profile/lpus/register/index/LpusRegisterContent/components/RegistrationForm/components/RegistrationFormAgreement.vue"
export default component.exports